import { Product } from '@uc/shared/data-models';

export interface BookmarkModel {
	id: number | undefined;
	uniName: string;
	delta: 1 | 2;
	saved: number | boolean | undefined;
	componentName: string | null;
	product: Product | '';
	ugSearchOrderPosition: number | null;
	clerSearchOrderPosition: number | null;
	courseSlug: string;
	year: number | undefined;
}

export enum BookmarkType {
	University,
	Course,
}
